// import {FIND_SUPERAGENT} from "../../routes";
// import customAxios from "../../customAxios";

type Props = {
  page?: number;
  limit?: number;
  endDate?: string;
  startDate?: string;
  // Search
  search?: {
    trackingCode: string;
  };
  // Filter
  filters?: {
    role: string | null;
    agent: string | null;
    status: string | null;
    driver: string | null;
    superAgent: string | null;
  };
};

async function getAllSuperAgent(props: Props) {
  // var thisUrl = FIND_SUPERAGENT + "?";
  // if (props.page) thisUrl += `page=${props.page}`;
  // if (props.limit) thisUrl += `&limit=${props.limit}`;
  // if (props.startDate && props.endDate) thisUrl += `&startDate=${props.startDate}&endDate=${props.endDate}`;
  // let body: any = {
  //   query: {
  //     userTypes: {
  //       $in: ["SUPER_AGENT"],
  //     },
  //   },
  // };
  // try {
  //   return (await customAxios.get(thisUrl, body)).data;
  // } catch (error: any) {
  //   console.log({FIND_SUPERAGENT: error});
  // }
}

export default getAllSuperAgent;
